<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0598 13.0006C24.7249 12.9696 29.3351 14.2266 35.138 16.7988L36 17.1809L25.2171 28.9992L24.7681 28.83C22.8479 28.1063 21.4112 27.7669 20.0054 27.7661C18.6 27.7652 17.165 28.1027 15.2484 28.8295L14.7987 29L4 17.1643L4.89149 16.7926C10.7568 14.3473 15.3999 13.0315 20.0598 13.0006ZM6.3321 17.6764L15.1975 27.3931C16.9874 26.7457 18.4836 26.4044 20.0062 26.4053C21.5287 26.4062 23.0258 26.7492 24.817 27.3938L33.6975 17.6605C28.4031 15.39 24.2286 14.3337 20.0693 14.3613C15.9091 14.3889 11.6996 15.5009 6.3321 17.6764Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.295 17L21 28.4465L19.705 29L14 17.5535L15.295 17Z"
      class="fill-current"
    />
  </svg>
</template>
